import { j as e } from "./jsx-runtime-944c88e2.js";
import { b as s } from "./index-a0534bb4.js";
import { Card as n, CardHeader as d, CardBody as a } from "./card.js";
import "react";
import "./index-efd35e77.js";
import "./index-93802845.js";
import "./index-c07310bf.js";
import "./index-64063129.js";
import "react-dom";
import "./auto-scroll-b2de6e53.js";
import "./index.es-6889c727.js";
import "./Label-079ad7bc.js";
import "./package-metadata-3dcf116a.js";
import "./FloatingLabel-922c628f.js";
import "./Button-4c83e316.js";
import "./package-metadata-9ad1330d.js";
import "./theme-b013fa81.js";
import "./ButtonGroup-a9850ef0.js";
import "./Popup-b6c9078b.js";
import "./surface-71c0d1c6.js";
import "./Dialog-a72b336a.js";
import "./button.js";
import "./Ripple-5a8cf54c.js";
import "./icon.js";
import "./Enums-2eefd6e1.js";
import "./package-metadata-a152adb8.js";
const m = (t) => /* @__PURE__ */ e.jsx(s, { ...t, labelPlacement: "after", size: "medium", children: t.children }), F = (t) => {
  const o = t.useHeader ?? !0, r = (i) => {
    t.onChange !== void 0 && t.onChange({
      value: t.value,
      syntheticEvent: i.syntheticEvent,
      target: i.target,
      nativeEvent: i.nativeEvent
    });
  }, l = t.checked ? "k-card-primary" : "k-card-default";
  return o ? /* @__PURE__ */ e.jsxs(n, { style: { display: "flex", minWidth: "15%", maxWidth: "40%", cursor: "pointer" }, onClick: r, children: [
    /* @__PURE__ */ e.jsx(d, { className: l, style: { justifyContent: "center", display: "grid" }, children: t.label }),
    /* @__PURE__ */ e.jsxs(a, { style: { flexDirection: "column", justifyItems: "center", display: "grid" }, children: [
      /* @__PURE__ */ e.jsx("div", { style: { flexWrap: "wrap" }, children: t.text }),
      /* @__PURE__ */ e.jsx(m, { ...t, label: "" })
    ] })
  ] }) : /* @__PURE__ */ e.jsx(n, { style: { display: "flex", minWidth: "15%", maxWidth: "40%", cursor: "pointer" }, onClick: r, children: /* @__PURE__ */ e.jsxs(a, { style: { flexDirection: "column", justifyItems: "center", display: "grid" }, className: l, children: [
    /* @__PURE__ */ e.jsx("div", { style: { fontWeight: "bold" }, children: t.label }),
    /* @__PURE__ */ e.jsx("div", { style: { flexWrap: "wrap" }, children: t.text }),
    /* @__PURE__ */ e.jsx(m, { ...t, label: "" })
  ] }) });
};
export {
  m as RadioButton,
  F as RadioCard
};
